const bridge = () => typeof window !== "undefined" ? window.desktopOfflineStaff : null;
const requireBridge = () => {
  const api = bridge();
  if (!api) throw new Error("Restart the desktop app to initialize offline staff management.");
  return api;
};

export const listOfflineStaff = (restaurantId) => requireBridge().list({ restaurantId });
export const createOfflineStaff = (restaurantId, staff) => requireBridge().create({ restaurantId, ...staff });
export const updateOfflineStaff = (restaurantId, staffId, staff) => requireBridge().update({ restaurantId, staffId, ...staff });
export const toggleOfflineStaff = (staffId, active) => requireBridge().toggle({ staffId, active });
export const deleteOfflineStaff = (staffId) => requireBridge().remove({ staffId });
export const changeOfflineStaffPassword = (restaurantId, staffId, password) =>
  requireBridge().changePassword({ restaurantId, staffId, password });
export const forceLogoutOfflineStaff = (restaurantId, staffId) =>
  requireBridge().forceLogout({ restaurantId, staffId });
export const loginOfflineStaff = (phone, password) =>
  requireBridge().login({ phone, password });
export const validateOfflineStaffSession = (staffId, sessionToken) =>
  requireBridge().validateSession({ staffId, sessionToken });
export const getOfflineRolePermissions = (restaurantId, role = null) =>
  requireBridge().getPermissions({ restaurantId, role });
export const saveOfflineRolePermissions = (restaurantId, permissions, dashboard) =>
  requireBridge().savePermissions({ restaurantId, permissions, dashboard });
